/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Badge_Open_SourceInputs */

const en_directory_badge_open_source = /** @type {(inputs: Directory_Badge_Open_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Source`)
};

const zh_directory_badge_open_source = /** @type {(inputs: Directory_Badge_Open_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源`)
};

/**
* | output |
* | --- |
* | "Open Source" |
*
* @param {Directory_Badge_Open_SourceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_badge_open_source = /** @type {((inputs?: Directory_Badge_Open_SourceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Badge_Open_SourceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_badge_open_source(inputs)
	return zh_directory_badge_open_source(inputs)
});
export { directory_badge_open_source as "directory.badge.open_source" }